import React from "react";
import {withNamespaces} from "react-i18next";

import {
    crossDockingBenefitKeys,
    crossDockingNewsHref,
} from "../../content/cross-docking";
import LandingSalesCard from "../../ui/LandingSalesCard";
import CrossDockingFlow from "./CrossDockingFlow";
import "./style.less";

export function CrossDockingSection({t}) {
    return (
        <section
            className="landing-cross-docking landing-section landing-section--middle"
            id="cross-docking"
        >
            <div className="container public-site-shell">
                <div className="landing-cross-docking__heading landing-section-heading">
                    <div>
                        <span className="landing-section-heading__eyebrow">
                            {t(
                                "main.landing.crossDocking.eyebrow"
                            )}
                        </span>

                        <h2 className="landing-section-heading__title">
                            {t(
                                "main.landing.crossDocking.title"
                            )}
                        </h2>
                    </div>

                    <p className="landing-section-heading__intro">
                        {t(
                            "main.landing.crossDocking.intro"
                        )}
                    </p>
                </div>

                <div className="landing-cross-docking__layout">
                    <LandingSalesCard
                        eyebrow={t(
                            "main.landing.crossDocking.sales.eyebrow"
                        )}
                        title={t(
                            "main.landing.crossDocking.sales.title"
                        )}
                        description={t(
                            "main.landing.crossDocking.sales.description"
                        )}
                        benefits={crossDockingBenefitKeys.map(
                            (benefitKey) => ({
                                id: benefitKey,
                                label: t(benefitKey),
                            })
                        )}
                        primaryAction={{
                            href: "/register",
                            label: t(
                                "main.landing.crossDocking.sales.action"
                            ),
                        }}
                        secondaryAction={{
                            href: crossDockingNewsHref,
                            label: t(
                                "main.landing.crossDocking.sales.details"
                            ),
                        }}
                    />
                    <CrossDockingFlow t={t}/>
                </div>
            </div>
        </section>
    );
}

export default withNamespaces("translation")(
    CrossDockingSection
);
